import { render, staticRenderFns } from "./Songs.vue?vue&type=template&id=75e4ba3c&scoped=true&"
import script from "./Songs.vue?vue&type=script&lang=ts&"
export * from "./Songs.vue?vue&type=script&lang=ts&"
import style0 from "./Songs.vue?vue&type=style&index=0&id=75e4ba3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e4ba3c",
  null
  
)

export default component.exports